import React, {
  useState, useEffect, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import classNames from 'classnames';

import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Error from '@components/form/error';
import { useIsMount } from '@hooks/useIsMount';

export default function Editor({ label, ...props }) {
  const isMount = useIsMount();
  const [field, meta, helpers] = useField(props);
  const [value, setValue] = useState(field.value);

  const classes = useMemo(() => classNames(
    'input__wrapper',
    { error: meta.touched && !!meta.error },
  ), [field, meta]);

  useEffect(() => {
    let timer = null;
    if (!isMount) {
      timer = setTimeout(() => helpers.setValue(value), 1000);
    }

    return () => clearTimeout(timer);
  }, [value]);

  return (
    <div className={classes}>
      {!!label && <label>{label}</label>}
      <CKEditor
        editor={ClassicEditor}
        data={field.value}
        onChange={(event, editor) => {
          setValue(editor.getData());
        }}
      />
      <Error name={field.name} />
    </div>
  );
}

Editor.defaultProps = {
  label: '',
};

Editor.propTypes = {
  label: PropTypes.string,
};
